(ns frontend.actions.attestation
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]))

(defn *->create
  "Create attestation with associated condition entities.
   Data: {:attestation-id string, :entities {string -> entity-map}}"
  [data on-success! on-error!]
  (-> (conn/sendp! :transaction-process/create-attestation
                   data
                   120000)
      (p/then (fn [{:keys [body] :as resp}]
                (if (:db/id body)
                  (on-success! resp)
                  (on-error! resp))))
      (p/catch on-error!)))

(defn *->create-condition
  "Create a condition for an existing transaction-process attestation."
  [{:keys [data on-success on-error]}]
  (-> (conn/sendp! :transaction-process/create-attestation-condition
                   data
                   120000)
      (p/then (fn [{:keys [body] :as resp}]
                (if (:db/id body)
                  (on-success resp)
                  (on-error resp))))
      (p/catch on-error)))
